import React from 'react';
import ReportPermissionChecker from './components/ReportPermissionChecker';
import AddReportV3 from './v3/components/AddReport';

const AddReport: React.FC = () => (
  <ReportPermissionChecker mode="edit">
    <AddReportV3 />
  </ReportPermissionChecker>
);

export default AddReport;
